$(() => {
  $(".zi-model-img").mousemove(function (e) {
    var left = e.clientX - ($(this).offset().left - $(window).scrollLeft());
    var top = e.clientY - ($(this).offset().top - $(window).scrollTop());
    var leftP = left / $(this).innerWidth();
    var topP = top / $(this).innerHeight();
    // console.log(leftP, topP);
    var X = (1 - leftP) * 200 - 100;
    var Y = (1 - topP) * 230 - 120;
    $(".zi-scale-img").css({
      top: Y + "%",
      left: X + "%",
    });
  });
});

// accordian

$(() => {
  $("#care").click(function () {
    $("#featurediv").hide();
    $("#feature").removeClass("rotateblank1");
    $("#fabricdiv").hide();
    $("#fabric").removeClass("rotateblank2");
    $("#sharediv").hide();
    $("#share").removeClass("rotateblank3");
    if ($(this).hasClass("rotateblank")) {
      $("#carediv").hide();
      $(this).removeClass("rotateblank");
    } else {
      $("#carediv").show();
      $(this).addClass("rotateblank");
    }
  });
  $("body").on("click", ".colors", function () {
    $("#color_id_quickadd").val($(this).data("color_id"));
    var id = $(this).data("id");
    $(".colors").removeClass("selected");
    $(this).addClass("selected");
    // console.log(".color-quickadd-id-" + id);
    $("#color-quickadd-id-" + id)
      .siblings("ul")
      .hide();
    $("#color-quickadd-id-" + id).show();
    $(".sizes").removeClass("selected");
    $("#quick-add-btn").attr("disabled", true);
    $("#size_id_quickadd").val("");

    $(".imageclass" + id).click();
  });
  $("body").on("click", ".sizes", function () {
    $("#size_id_quickadd").val($(this).data("size_id"));
    $("#quick-add-btn").attr("disabled", false);
    $(".sizes").removeClass("selected");
    $(this).addClass("selected");
  });
  $("#feature").click(function () {
    $("#carediv").hide();
    $("#care").removeClass("rotateblank");
    $("#fabricdiv").hide();
    $("#fabric").removeClass("rotateblank2");
    $("#sharediv").hide();
    $("#share").removeClass("rotateblank3");
    if ($(this).hasClass("rotateblank1")) {
      $("#featurediv").hide();
      $(this).removeClass("rotateblank1");
    } else {
      $("#featurediv").show();
      $(this).addClass("rotateblank1");
    }
  });

  $("#fabric").click(function () {
    $("#carediv").hide();
    $("#care").removeClass("rotateblank");
    $("#featurediv").hide();
    $("#feature").removeClass("rotateblank1");
    $("#sharediv").hide();
    $("#share").removeClass("rotateblank3");
    if ($(this).hasClass("rotateblank2")) {
      $("#fabricdiv").hide();
      $(this).removeClass("rotateblank2");
    } else {
      $("#fabricdiv").show();
      $(this).addClass("rotateblank2");
    }
  });
  $("#share").click(function () {
    $("#carediv").hide();
    $("#care").removeClass("rotateblank");
    $("#featurediv").hide();
    $("#feature").removeClass("rotateblank1");
    $("#fabricdiv").hide();
    $("#fabric").removeClass("rotateblank2");
    if ($(this).hasClass("rotateblank3")) {
      $("#sharediv").hide();
      $(this).removeClass("rotateblank3");
    } else {
      $("#sharediv").show();
      $(this).addClass("rotateblank3");
    }
  });
    $("#shipping-customs").click(function () {
    $("#carediv").hide();
    $("#care").removeClass("rotateblank");
    $("#featurediv").hide();
    $("#feature").removeClass("rotateblank1");
    $("#fabricdiv").hide();
    $("#fabric").removeClass("rotateblank2");
    if ($(this).hasClass("rotateblank3")) {
      $("#shipping-customsdiv").hide();
      $(this).removeClass("rotateblank3");
    } else {
      $("#shipping-customsdiv").show();
      $(this).addClass("rotateblank3");
    }
  });
});
// end accordian

$(() => {
  if (screen.width > 576 && !document.body.classList.contains('gift-card')) {
    $(window).scroll(function () {
      var z = $(".banner-zara").height() - 300;
      var b = $(this).scrollTop();
      let h = $(".zara-content").height();
      if ($(".dd").outerHeight() > $(".zara-content").height()) {
        let extraHeight = $(".dd").outerHeight() - $(".zara-content").height();
        z = $(".banner-zara").height() + 120 - $(window).height();
        if (b > z) {
          let a = b - z;
          //console.log(a)
          b = b > extraHeight ? extraHeight : b;
          b += a;
        } else {
          b = b > extraHeight ? extraHeight : b;
        }
        $(".dd").css("top", -b);
      } else {
        z = $(".banner-zara").height() + 120 - $(window).height();
        h = $(".dd").height() - 250;
        if (b > z) {
          let a = b - z;
          b = b > h ? h : b;
          b += a;
          $(".dd").css("top", -b);
        } else {
          $(".dd").css("top", 0);
        }
      }
    });
  }
});

// size popup

$("#hit-size").click(function () {
  $(".quick-view-pop").show();
});

$(".account-pop-close").click(function () {
  $(".quick-view-pop").hide();
});

// end size popup
